import { find, reduce, groupBy, map, each, clone } from 'underscore';

const formatOptions = (options) => {
  const groupedByCategoryId = groupBy(options, 'CategoryId');
  let idItr = -1;

  const getNextId = () => {
    idItr += 1;

    return idItr;
  };

  const formatted = map(groupedByCategoryId, optionGroup => ({
    id: getNextId(),
    categoryId: optionGroup[0].CategoryId,
    name: optionGroup[0].CategoryName,
    state: {
      expanded: true,
      disabled: true,
    },
    children: map(optionGroup, option => ({
      id: getNextId(),
      optionId: option.Id,
      name: option.FriendlyName,
    })),
  }));

  return formatted;
};

const getSelectionFromTreeNodes = (nodes) => {
  const selections = [];
  each(nodes, (parentNode) => {
    each(parentNode.children, (node) => {
      if (node.state && node.state.checked) {
        selections.push({
          CategoryId: parentNode.categoryId,
          TargetOptionId: node.optionId,
        });
      }
    });
  });

  return selections;
};

const getSelectionFromCriterions = criterions => map(
  criterions,
  (item) => {
    if (item.Criterion.ContextualTarget) {
      return {
        CategoryId: item.Criterion.ContextualTarget.CategoryId,
        TargetOptionId: item.Criterion.ContextualTarget.TargetOptionId,
        CriterionId: item.Id,
      };
    }
    return {
      CategoryId: item.Criterion.CategoryId,
      TargetOptionId: item.Criterion.TargetOptionId,
      CriterionId: item.Id,
    };
  }
);

const applySelectionToTreeNodes = (nodes, selections) => {
  const allChildren = reduce(nodes, (memo, cur) => memo.concat(cur.children), []);
  each(selections, (selection) => {
    const targetOptionNode = find(allChildren, node => node.optionId === selection.TargetOptionId);

    if (targetOptionNode) {
      targetOptionNode.state = {
        checked: true,
      };
    }
  });
};

const selectionComparer = (selection1, selection2) => selection1.CategoryId === selection2.CategoryId && selection1.TargetOptionId === selection2.TargetOptionId;

const onlyInLeft = (left, right, compareFunction) =>
  left.filter(leftValue =>
    !right.some(rightValue =>
      compareFunction(leftValue, rightValue)));

const getSelectionsByComparison = (selections, newSelections) => {
  const addedSelections = onlyInLeft(newSelections, selections, selectionComparer);
  const removedSelection = onlyInLeft(selections, newSelections, selectionComparer);

  return {
    added: addedSelections,
    removed: removedSelection,
  };
};

const getContextualTargetInfo = (selections, newSelections) => {
  const { added, removed } = getSelectionsByComparison(selections, newSelections);
  const removedWithStatusUpdate = map(removed, (item) => {
    const copied = clone(item);
    copied.IsRemoved = true;

    return copied;
  });

  const combinedSelectionWithStatus = [...added, ...removedWithStatusUpdate];

  // Handle the deletion.
  return map(combinedSelectionWithStatus, (selection) => {
    const criterion = {
      Criterion: {
        BidAdjustment: 0,
        ContextualTarget: {
          CategoryId: selection.CategoryId,
          TargetOptionId: selection.TargetOptionId,
        },
        Type: 'ContextualTarget',
      },
      CriterionType: 'ContextualTarget',
    };

    if (selection.IsRemoved) {
      criterion.Status = 'Deleted';
      criterion.Id = selection.CriterionId;
    }

    return criterion;
  });
};

export {
  formatOptions,
  getSelectionFromTreeNodes,
  getSelectionFromCriterions,
  applySelectionToTreeNodes,
  getContextualTargetInfo,
};
